// @flow
import React from 'react';
import styled, { css } from 'react-emotion';
import { colors, fonts } from '../assets/scripts/constants';

/**
 * Styles
 */

const defaultCss = ({ bgColor, large, xlarge }) => css`
  margin-top: ${large && 'auto'};
  text-align: ${large ? 'center' : 'right'};

  > button {
    padding: 0.45em 1em 0.5em;
    font-family: ${fonts.primary};
    font-size: ${large ? 1.8 : 1.3}em;
    font-size: ${xlarge && '2em'};
    font-weight: 600;
    line-height: initial;
    border: 0;
    border-radius: 1em;
    color: ${colors.white};
    background-color: ${large ? colors.black : colors.orange};
    background-color: ${bgColor};
    transition: ${large
      ? 'background-color 0.3s, box-shadow 0.3s;'
      : 'background-color 0.1s, box-shadow 0.1s;'};
    cursor: pointer;

    &:focus {
      box-shadow: inset 0px 3px 14px 0px rgba(0, 0, 0, 0.3);
      outline: 0;
    }

    &[disabled] {
      background-color: ${xlarge ? colors.gray : colors.grayDark};
      cursor: auto;
    }

    /* For xlarge / cart */
    > div {
      line-height: 1;

      > img,
      > span {
        vertical-align: middle;
      }

      > img {
        margin-right: 0.4em;
      }
    }
  }
`;

const navigatorCss = css`
  > button {
    display: block;
    padding: 0.5em 1em 0;
    border: 0;
    background-color: transparent;
    transition: transform 0.3s;
    cursor: pointer;

    &:hover {
      transform: scale(1.3);
    }

    &:focus {
      transform: scale(1.4);
      outline: 0;
    }

    &[disabled] {
      visibility: hidden;
      cursor: auto;
    }
  }
`;

const Wrapper = styled('div')`
  display: ${({ xlarge }) => (xlarge ? 'inline-block' : 'block')};
  ${({ navigator }) => (navigator ? navigatorCss : defaultCss)};
`;

/**
 * Component: Button
 *
 * General button component.
 */
function Button(props: {
  bgColor?: string | false,
  children: Object | string,
  disabled?: mixed,
  large?: boolean,
  xlarge?: boolean,
  navigator?: boolean,
  onClick: Function,
}) {
  const {
    bgColor,
    children,
    disabled,
    large,
    xlarge,
    navigator,
    onClick,
  } = props;
  return (
    <Wrapper
      bgColor={bgColor}
      large={large}
      xlarge={xlarge}
      navigator={navigator}
    >
      <button onClick={onClick} disabled={disabled}>
        {children}
      </button>
    </Wrapper>
  );
}

Button.defaultProps = {
  bgColor: false,
  disabled: false,
  large: false,
  xlarge: false,
  navigator: false,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js